import React from "react";
import { Card } from "react-bootstrap";
import { FaStar, FaMapMarkerAlt, FaPhone, FaComment } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/Drivers/Rides/RideCard.css";

const RideCard = ({
  ride,
  showPickupButton = false,
  showActionButtons = false,
  onClick,
}) => {
  const navigate = useNavigate();

  return (
    <Card className="ride-card" onClick={onClick}>
      {/* Header - Name, Rating, Price */}
      <div className="ride-card__header">
        <div className="ride-card__user-info">
          <div className="ride-card__avatar">
            {ride.tdcustomer?.customer_image ? (
              <img
                src={ride.tdcustomer.customer_image}
                alt={ride.tdcustomer?.name || "Customer"}
              />
            ) : (
              <span>{ride.tdcustomer?.name?.charAt(0) || "U"}</span>
            )}
          </div>
          <div className="ride-card__user-details">
            <h6>{ride.tdcustomer?.name || "Customer"}</h6>
            <div className="ride-card__rating">
              <FaStar size={12} className="ride-card__star-icon" />
              <span>{ride.tdcustomer?.rating ?? "New"}</span>
            </div>
          </div>
        </div>
        <div className="ride-card__price">Rs{ride.offeredFare}</div>
      </div>

      {/* Date & Time */}
      <div className="ride-card__datetime">
        <span>{ride.bookingDate}</span>
      </div>

      {/* Pickup Location */}
      <div className="ride-card__location">
        <FaMapMarkerAlt className="ride-card__location-icon ride-card__location-icon--pickup" />
        <span className="ride-card__location-text">{ride.pickuplocation}</span>
      </div>

      {/* Drop Location */}
      <div className="ride-card__location">
        <FaMapMarkerAlt className="ride-card__location-icon ride-card__location-icon--drop" />
        <span className="ride-card__location-text">{ride.dropofflocation}</span>
      </div>

      {/* Action Buttons - Conditional */}
      {showActionButtons && (
        <div className="ride-card__actions">
          <button
            className="ride-card__action-btn ride-card__action-btn--call"
            onClick={(e) => {
              e.stopPropagation();
              window.open(`tel:${ride.tdcustomer?.phone}`);
            }}
          >
            <FaPhone size={14} className="ride-card__phone-icon" />
          </button>
          <button
            className="ride-card__action-btn ride-card__action-btn--message"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/driver-chat");
            }}
          >
            <FaComment size={14} />
          </button>
        </div>
      )}

      {/* Pickup Button - Conditional */}
      {showPickupButton && (
        <button
          className="ride-card__pickup-btn"
          onClick={(e) => {
            e.stopPropagation();
            onClick(ride);
          }}
        >
          Pickup Customer
        </button>
      )}
    </Card>
  );
};

export default RideCard;